import _styled from "styled-components";
var _excluded = ["active", "children", "compact", "customBackgroundColor", "fullWidth", "loading", "textColorMode"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ButtonInnerWithLoadingState } from "../ButtonInner/ButtonInnerWithLoadingState";
import { getCustomBackgroundStyle, getHoverStyle } from "./getCustomStyles";
import { buttonSize } from "../styles/buttonSizes.styles";
import * as styles from "./SolidButton.styles";
export var SolidButtonLink = function SolidButtonLink(_ref) {
  var active = _ref.active,
    children = _ref.children,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    customBackgroundColor = _ref.customBackgroundColor,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$textColorMode = _ref.textColorMode,
    textColorMode = _ref$textColorMode === void 0 ? 'light' : _ref$textColorMode,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledA, _extends({
    "data-is-active": active
  }, props, {
    $_css: [styles.solidButtonLink, getHoverStyle(textColorMode, customBackgroundColor), getCustomBackgroundStyle(customBackgroundColor), buttonSize(compact, fullWidth)]
  }), /*#__PURE__*/React.createElement(ButtonInnerWithLoadingState, {
    compact: compact,
    loading: loading,
    textColorMode: textColorMode
  }, children));
};
var _StyledA = /*#__PURE__*/_styled("a").withConfig({
  displayName: "SolidButtonLink___StyledA",
  componentId: "sc-xs8pq0-0"
})(["", ""], function (p) {
  return p.$_css;
});